
import { AmmunitionStockEntityDecorator } from './ammunition-stock.decorator';
import { AmmunitionStock } from './ammunition-stock.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockTypeInfoBase implements CrudTypeInfo<AmmunitionStock, number> {
  name = 'Ammunition Stock';
  entityDecorator = new AmmunitionStockEntityDecorator();
  
  createAuthorities = ['WRITE_AMMUNITION_STOCK'];
  editAuthorities = ['WRITE_AMMUNITION_STOCK'];
  deleteAuthorities = ['WRITE_AMMUNITION_STOCK'];
  viewAuthorities = ['READ_AMMUNITION_STOCK'];
  
  searchRouteBase = ['/ammunitionstock/search'];
  createRouteBase = ['/ammunitionstock/create'];
  editRouteBase = ['/ammunitionstock/edit'];
  viewRouteBase = ['/ammunitionstock/view'];
  
  description(item: AmmunitionStock): string {
    return '' +  item.ammunitionStockId;
  }
}



